// Trim a string, and add ... if it's longer than the specified length
export function trimString(str: string, length: number): string {
  return str.length > length ? str.substring(0, length) + '...' : str;
}
